import { Component, computed, effect, inject, input, LOCALE_ID, output, signal, untracked } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Loading } from '../../../../utils/loading/loading';
import { Error } from '../../../public-user-component/auth/shared/error/error';
import { FilterProductSearch } from '../../../../shared/ui/shared-filters/filter-product-search/filter-product-search';

@Component({
  selector: 'app-assign-representative',
  imports: [ReactiveFormsModule, Loading, Error, FilterProductSearch],
  templateUrl: './assign-representative.html',
  styleUrl: './assign-representative.scss',
})
export class AssignRepresentative {
  private locale = inject(LOCALE_ID);

  layout = input<'form' | 'filter'>('form');
  clear = input<number>(0);

  pharmacyForm = input.required<FormGroup>();
  showRepresentativeDropdown = input.required<boolean>();
  representativeResults = input.required<{ id: number; fullName: string }[]>();
  selectedRepresentativeName = signal<string>('');
  selectRepresentative = output<{
    id: string;
    fullName: string;
  }>();
  searchChange = output<string>();
  loadingRepresentative = input.required<boolean>();
  errorRepresentative = input.required<boolean>();

  filterSearchTerm = signal('');
  filterShowDropdown = signal(false);

  filterResults = computed(() =>
    this.representativeResults().map((r) => ({ id: r.id, titleAr: r.fullName, titleEn: r.fullName })),
  );

  constructor() {
    let isFirstRun = true;
    effect(() => {
      this.clear();
      if (isFirstRun) {
        isFirstRun = false;
        return;
      }
      untracked(() => {
        this.filterSearchTerm.set('');
        this.filterShowDropdown.set(false);
        this.selectedRepresentativeName.set('');
      });
    });
  }

  onSelectRepresentative(id: string, fullName: string) {
    this.selectedRepresentativeName.set(fullName);
    this.selectRepresentative.emit({ id, fullName });
  }

  onFilterSearch(term: string) {
    this.filterShowDropdown.set(!!term);
    this.searchChange.emit(term);
  }

  onFilterSelect(item: { id: number; titleEn: string }) {
    this.onSelectRepresentative(String(item.id), item.titleEn);
  }

  isArabic() {
    return this.locale.startsWith('ar');
  }
}
